import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=b6ccfcf6&scoped=true"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=b6ccfcf6&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ccfcf6",
  null
  
)

export default component.exports